import { render, staticRenderFns } from "./SkeletonCategoryCourse.vue?vue&type=template&id=62e82fd3&scoped=true"
import script from "./SkeletonCategoryCourse.vue?vue&type=script&lang=js"
export * from "./SkeletonCategoryCourse.vue?vue&type=script&lang=js"
import style0 from "./SkeletonCategoryCourse.vue?vue&type=style&index=0&id=62e82fd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e82fd3",
  null
  
)

export default component.exports